import { Directive, HostListener, Input } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CommunicationEventService, EventLog } from 'src/app/services/communication-event.service';

@Directive({
  selector: '[ga-event]'
})
export class GoogleAnalyticsEventsDirective {

  constructor(private analyticsService: AnalyticsService, private eventLog: CommunicationEventService) { }

  @Input('ga-event') payload: string | EventLog;
  @Input('ga-event-related') relatedItems: { Id: string, Index: string, Relation: string }[];
  @Input('ga-event-data') data: { [key: string]: string };
  @HostListener('click') click() {
    try {
      if (!this.payload)  return; 
      let event: EventLog = null;
  
      if(typeof(this.payload)=='string') {
        const parts = (<string>this.payload).split('|');
        event = <EventLog>{ Category: parts[1] || '', Action: parts[0] || '', Label: parts[2] || '', NonInteraction: !!parts[3], Value: +parts[4] || 0}
        this.analyticsService.gtmEvent( event.Category, event.Action, event.Label, event.NonInteraction, event.Value);
      } 
      else {
        event = <EventLog>this.payload;
        event.RelatedItems = this.relatedItems;
        event.Data = this.data;
        this.eventLog.log(event);
      }
        
    } catch (error) {
      console.error('GoogleAnalyticsEventsDirective',  error);
    }
  }
}
